import { AfterViewInit, Component, OnInit, ViewChild, NgZone, ElementRef, VERSION, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { DOCUMENT } from '@angular/common';
import { logbaseService } from '../../services/logbase.service';
import { dataService } from '../../services/data.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';

import { dateFormatPipe } from '../../pipes/dateFormatPipe'
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'

export interface SupplierData{
partNumber:ElementRef;
partName:any;
packageId:any;
deliveryPoint:any;
nextProcess:any;
assignedDate:any;
dueDate:any;
}

@Component({
  selector: 'app-supplier-database',
  templateUrl: './supplier-database.component.html',
  styleUrls: ['./supplier-database.component.scss']
})
export class SupplierDatabaseComponent implements OnInit {

  displayedColumns = ['partNumber', 'partName', 'packageId','nextProcess', 'deliveryPoint','assignedDate','dueDate'];
  dataSource: MatTableDataSource<SupplierData[]>;

  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  notallowed: boolean;
  userIDTaken: boolean;
  itemSelectedDeliverypoint: any = []
  lineNumbers: any;
  deliveryPoints: any;
  deliveryCodeList: any;
  deliveryCodes: any;
  settingsdelieverypoint: any;
  settingsoperation: any;
  newPartsData: any[] = [];
  parts: any;
  lineCodes: any;
  lineCodeList: any;
  itemSelectedOperation: any = []
  searchInput:any;
  // ng2-table code

  public rows: Array<any> = [];
  public columns: Array<any> = [
    { title: 'Part No', name: 'partNumber' },
    { title: 'Part Name', name: 'partName' },
    { title: 'Package ID', name: 'packageId' },
    { title: 'Delivery Point', name: 'deliveryPoint' },
    { title: 'Next Process', name: 'lineNumber' },
    { title: 'Assigned Date', name: 'assignedDate' },
    { title: 'Due Date', name: 'dueDate' }
  ];
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };

  private data: Array<any> = [];

  // ng2-table code ends

  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: any, private logbaseService: logbaseService,
    private dataService: dataService, private spinner: NgxSpinnerService, private translate: TranslateService,
    private httpClient: HttpClient, private ref: ChangeDetectorRef, private toaster: ToastrService) {

  }

  ngOnInit() {
    this.spinner.show();
    this.userIDTaken = true;
    this.notallowed = true;
    //this.onChangeTable(this.config, true);  
    // this.logbaseService.getSupplierDatabaseLineNumbers()
    this.logbaseService.getSuppLineNumbers()
      .subscribe(result => {
        this.lineCodes = result.response;
        this.spinner.hide();
        var lineCodeListArr = [];
        this.lineCodes.forEach(function (value, key) {
          lineCodeListArr.push({ "id": key + 1, "itemName": value });
        });
        this.lineCodeList = lineCodeListArr;
      });


    this.logbaseService.getDeliveryPoints()
      .subscribe(result => {
        this.deliveryCodes = result.response;
        this.spinner.hide();
        let deliveryCodeListArr = [];
        var dlvcd = [];
        this.deliveryCodes.forEach(function (value) {
          dlvcd.push(value.deliveryPoint);
        })
        dlvcd.forEach(function (value, key) {
          deliveryCodeListArr.push({ "id": key + 1, "itemName": value });
        });
        this.deliveryCodeList = deliveryCodeListArr;
        console.log("deliveryCodeList",this.deliveryCodeList)
        
      });

    this.settingsoperation = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: false,
      text: this.translate.instant("Select Next Process"),
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes: "custom-class",
      itemsShowLimit: 10,
      limitSelection: 10
    };
    this.settingsdelieverypoint = {
      idField: 'id',
      textField: 'itemName',
      singleSelection: false,
      text: this.translate.instant("Select Delivery Point"),
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      // classes: "custom-class",
      itemsShowLimit: 10,
      limitSelection: 10
    }
  }

  applyFilter(event: Event) {
    
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    console.log("data source",this.dataSource)
    // console.log("event",(event.target as HTMLInputElement).value)
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  exportCSV() {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      headers: ['Part Number', 'Part Name', 'Package ID', 'Delivery Point', 'Next Process', 'Assigned Date', 'Due Date']
    };
    new AngularCsv(this.newPartsData, 'Approved Parts', options);

  }
  onSingleSelectOperation(item: any) {
    this.itemSelectedOperation.push(item.itemName);
    this.userIDTaken = false;
  }
  onDeSelectOperation(yes: any) {

    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.itemSelectedOperation.indexOf(yes.itemName);
    this.itemSelectedOperation.splice(index, 1);
    if (this.itemSelectedDeliverypoint.length == 0 && this.itemSelectedOperation.length == 0) {
      this.userIDTaken = true;
    }
    else {
      this.userIDTaken = false;
    }
  }

  onSelectAllOperation(yes: any) {
    yes.forEach(element => {
      this.itemSelectedOperation.push(element.itemName);

    });
    this.userIDTaken = false;
  }
  DeSelectAllOperation(yes: any) {

    this.itemSelectedOperation = [];
    this.userIDTaken = true;
  }




  onSingleSelectdeliverypoint(item: any) {
    this.userIDTaken = false;
    this.itemSelectedDeliverypoint.push(item.itemName)
  }
  onDeSelectdeliverypoint(yes: any) {


    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.itemSelectedDeliverypoint.indexOf(yes.itemName);
    this.itemSelectedDeliverypoint.splice(index, 1);
    if (this.itemSelectedDeliverypoint.length == 0 && this.itemSelectedOperation.length == 0) {
      this.userIDTaken = true;
    }
    else {
      this.userIDTaken = false;
    }
  }

  onSelectAlldeliverypoint(yes: any) {
    this.userIDTaken = false;
    yes.forEach(element => {
      this.itemSelectedDeliverypoint.push(element.itemName);

    });
  }
  DeSelectAlldeliverypoint(yes: any) {
    this.userIDTaken = true;
    this.itemSelectedDeliverypoint = [];
  }
  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name].toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    console.log("config",config)
    var pageNo;
    var sortData;
  

    var dateFormatPipeFilter = new dateFormatPipe();

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = (page.page) - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != '') {
        sortData = {
          name: value ? value.name : '',
          sort: value.sort
        }
      }
    });

    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    let userRoleId = userDetJson.userRoleMappings[0].roleId;
    let userSuppCode = userDetJson.supplierCode;

    var dataToSend = {
      filteredDeliveryPoints: this.itemSelectedDeliverypoint,
      filteredLineNumbers: this.itemSelectedOperation,
      pageNum: pageNo,
      partStatus: "approved",
      roleId: userRoleId,
      searchValue: this.searchInput,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: "",
      supplierCodes: userSuppCode
    }
    this.spinner.show();
    this.logbaseService.getApprovePartsPage(dataToSend)
      .subscribe(result => {
        this.parts = result;
        this.spinner.hide();
        var partArr;
        var partsData = [];
        if (this.parts.response.content.length == 0) {
          this.notallowed = true;
          this.translate.get('No Records Found').subscribe(res => {
            this.toaster.warning(res);
          })
        }
        else {

          this.notallowed = false;
          this.parts.response.content.forEach(function (value, key) {
            partArr = {
              // partNumber: '<a target="blank" class="partno_column" href="#/partDetails/partsInfo/' + value.packageId + '">' + value.partNumber + '</a>',
              partNumber:value.partNumber,
              partName: value.partName,
              packageId: value.packageId,
              deliveryPoint: value.deliveryPoint,
              lineNumber: value.lineNumber,
              assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
              dueDate: dateFormatPipeFilter.transform(value.dueDate)
            };
            partsData.push(partArr);
          });

        }
        this.newPartsData = partsData;
        this.dataSource=new MatTableDataSource<SupplierData[]>(this.newPartsData);
        this.data = partsData;
        this.length = this.parts.response.totalElements;

        this.columns = [
          { title: this.translate.instant('PARTNO'), name: 'partNumber' },
          { title: this.translate.instant('PARTNAME'), name: 'partName' },
          { title: this.translate.instant('PACKAGEID'), name: 'packageId' },
          { title: this.translate.instant('DELIVERYPOINT'), name: 'deliveryPoint' },
          { title: this.translate.instant('LINENUMBER'), name: 'lineNumber' },
          { title: this.translate.instant('ASSIGNEDDATE'), name: 'assignedDate' },
          { title: this.translate.instant('DUEDATE'), name: 'dueDate' }
        ];
        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        //this.length = sortedData.length;

        this.rerenderTable(this.config, true);
        this.config.filtering.filterString = '';
        this.ref.detectChanges();
      });
  }

  public rerenderTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
  }

  public onCellClick(data: any): any {
  }
}